document.addEventListener('DOMContentLoaded', function () {

  const sections = document.querySelectorAll('.custom-location-switcher');

  sections.forEach(section => {

    const wrapper = section.querySelector('.comparison-wrapper');
    const before = section.querySelector('.comparison-image.before');
    const handle = section.querySelector('.slider-handle');

    if (!wrapper || !before || !handle) return;

    let isDragging = false;
    let startX = 0;
    let currentPercent = 50;
    let moved = false;

    // Set initial position
    setPosition(currentPercent);

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      currentPercent = percent;

     before.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
      handle.style.left = percent + '%';
    }

    function getPercentFromEvent(e) {
      const rect = wrapper.getBoundingClientRect();
      let clientX = e.touches ? e.touches[0].clientX : e.clientX;
      let x = clientX - rect.left;
      return (x / rect.width) * 100;
    }

    // START DRAG
    function startDrag(e) {
      isDragging = true;
      moved = false;
      startX = e.touches ? e.touches[0].clientX : e.clientX;

      document.body.classList.add('no-select');
    }

    // MOVE
    function onMove(e) {
      if (!isDragging) return;

      const percent = getPercentFromEvent(e);
      setPosition(percent);

      moved = true;
    }

    // END DRAG
    function endDrag(e) {
      if (!isDragging) return;

      isDragging = false;
      document.body.classList.remove('no-select');

      // Prevent accidental clicks if user dragged
      if (moved) {
        const links = section.querySelectorAll('a');
        links.forEach(link => {
          link.addEventListener('click', preventClickOnce, { once: true });
        });
      }
    }

    function preventClickOnce(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // EVENTS

    // Mouse
    handle.addEventListener('mousedown', startDrag);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', endDrag);

    // Touch
    handle.addEventListener('touchstart', startDrag, { passive: true });
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', endDrag);

    // Click on wrapper (jump to position)
    wrapper.addEventListener('click', function (e) {
      if (isDragging) return;

      const percent = getPercentFromEvent(e);
      setPosition(percent);
    });

  });

});